module.exports = __webpack_public_path__ + "img/examination.55873241.png";